import React, { useMemo } from 'react';
import styles from './DiceStats.module.scss';
import { useUIGameEndContext } from '../../../../../contexts/UIGameEndContext.tsx';
import { BarChart } from '../../BarChart/index.ts';
import { T } from '@colonist/ui';
import { useIsReplay } from '../../../../../store/selectors/useIsReplay.ts';
import { useGameStore } from '../../../../../store/GameStoreContext.ts';
export const DiceStats = ()=>{
    const { gameEndData } = useUIGameEndContext();
    const myColor = useGameStore((state)=>state.myColor);
    const sendWasDiceUnfairAnalytics = useGameStore((state)=>state.gameAnalytics.sendWasDiceUnfairAnalytics);
    const isReplay = useIsReplay();
    const chartData = useMemo(()=>gameEndData.endGameState.diceStats.map((item, index)=>({
                label: index + 2,
                value: item,
                barClassName: index + 2 === 7 ? styles.grayBar : null
            })), [
        gameEndData
    ]);
    const onClickWasDiceUnfair = ()=>{
        sendWasDiceUnfairAnalytics(myColor);
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.container
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.header
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.title
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:game.endGame.dice.rolls'
        }
    })), isReplay === false && /*#__PURE__*/ React.createElement("div", {
        className: styles.wasDiceUnfair
    }, /*#__PURE__*/ React.createElement("a", {
        href: "https://blog.colonist.io/balanced-dice-designing/",
        onClick: onClickWasDiceUnfair,
        rel: "noreferrer",
        target: "_blank"
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:game.endGame.footer.wasDiceUnfair'
        }
    })))), /*#__PURE__*/ React.createElement(BarChart, {
        chartData: chartData
    }));
};
